import { render, staticRenderFns } from "./SignupAgent.vue?vue&type=template&id=61a6ab8e&scoped=true&"
import script from "./SignupAgent.vue?vue&type=script&lang=js&"
export * from "./SignupAgent.vue?vue&type=script&lang=js&"
import style0 from "./SignupAgent.vue?vue&type=style&index=0&id=61a6ab8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a6ab8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
